export default "__VITE_ASSET__2992b1fa__"